import { DialogActions, DialogContent, Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { XsBaseDialog, XsButton } from '../../../global/ui';
import GlobalStore from '../../../global/stores/GlobalStore';

function ConfirmRegistrationDialog() {
  const { t } = useTranslation();

  return (
    <XsBaseDialog
      id='confirmRegistrationDialogOpened'
      open={GlobalStore.confirmRegistrationDialogOpened}
      onClose={() => GlobalStore.closeConfirmRegistrationDialog()}
      maxWidth='sm'
      fullWidth
    >
      <DialogContent>
        <Grid item container direction='column' xs={12} className='mt-1 mb-3' spacing={2}>
          <Grid item>
            <Typography variant='body1' className='bold'>
              {t('confirm_registration.success_title')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='body2'>{t('confirm_registration.success_text1')}</Typography>
          </Grid>
          <Grid item>
            <Typography variant='body2'>{t('confirm_registration.success_text2')}</Typography>
          </Grid>
          <Grid item>
            <Typography variant='body2'>{t('confirm_registration.success_text3')}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid item container justifyContent='flex-end' className='mr-2 mb-2'>
          <Grid item>
            <XsButton
              variant='contained'
              label='confirm_registration.button_ok'
              onClick={() => GlobalStore.closeConfirmRegistrationDialog()}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </XsBaseDialog>
  );
}

export default observer(ConfirmRegistrationDialog);
